export interface ICompany {
  companyId: number,
  name: string,
  companyDomain: string,
  currencyCode: string,
  isCurrencyMappingMatched: string,
  industry: string,
  status: TrialStatus,
  trialBalance: number
}

export enum TrialStatus {
  GettingStarted1 = "GettingStarted1",
  GettingStarted2 = "GettingStarted2",
  PreLive = "PreLive",
  OnTrial = "OnTrial",
  Live = "Live"
}

export interface ICompanyPagination {
  currentPage: number,
  pageCount: number,
  pageSize: number,
  rowCount: number,
  results?: Array<ICompany>
}